import React from "react";

const Footer = () => {
    return (
        <footer>
            <div>Tous droits réservés par Jean Baradat - Copyright 2022</div>
        </footer>
    );
};

export default Footer;
